import { FormControl, FormLabel, Grid, TextField } from '@mui/material';

import { Field, FieldAttributes, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { Description } from 'app/components/Description';
import StyledDropzone from 'app/components/Dropzone';
import { translations } from 'locales/i18n';

export default function MainContent() {
  const { t } = useTranslation();

  const { setFieldValue, values, errors, touched }: any = useFormikContext();

  return (
    <Grid container>
      <Grid container>
        <FormControl className="articleModal__body__input" required fullWidth>
          <FormLabel className="articleModal__body__input__label">
            {t(translations.common.title())}
          </FormLabel>
          <Field
            as={TextField}
            name="headline"
            variant="outlined"
            fullWidth
            error={touched.headline && errors.headline}
            helperText={touched.headline && errors.headline}
            required
          />
        </FormControl>
        <FormControl className="articleModal__body__input" required fullWidth>
          <FormLabel className="articleModal__body__input__label">
            {t(translations.pages.articles.create.mainContent.shortDescription())}
          </FormLabel>
          <Field
            as={TextField}
            name="shortDescription"
            variant="outlined"
            fullWidth
            error={touched.shortDescription && errors.shortDescription}
            helperText={touched.shortDescription && errors.shortDescription}
            required
            multiline
            rowsMax={3}
          />
        </FormControl>
        <FormControl className="articleModal__body__input" required fullWidth>
          <FormLabel className="articleModal__body__input__label">
            {t(translations.pages.articles.create.mainContent.articleText())}
          </FormLabel>
          <Field name="articleText" error={touched.articleText && errors.articleText}>
            {({ field }: { field: FieldAttributes<{}> }) => <Description field={field} />}
          </Field>
        </FormControl>
        <FormControl className="articleModal__body__input" fullWidth>
          <FormLabel className="articleModal__body__input__label">
            {t(translations.pages.articles.create.mainContent.attachements())}
          </FormLabel>
        </FormControl>
        <StyledDropzone
          name="attachement"
          setFieldValue={setFieldValue}
          value={values.attachement}
          errors={errors}
          accept={{
            'application/msword': ['.doc', '.dot'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
              '.docx',
              '.dotx'
            ],
            'application/pdf': ['.pdf'],
            'application/zip': ['.zip'],
            'image/jpeg': ['.jfif', '.jfif-tbnl', '.jpe', '.jpeg', '.jpg']
          }}
          placeholder={t(
            translations.pages.articles.create.mainContent.attachementUploadPlaceholder()
          )}
          className="articleModal__body__input__dropzone"
        />
      </Grid>
    </Grid>
  );
}
